// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'share-document';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 10.593v6.375m0-1.063h10.625a2.125 2.125 0 0 0-2.125-2.124H6.875a2.125 2.125 0 0 0-2.125-2.126H1.031M4.75 13.78h2.125m6.198.002h3.187a.708.708 0 0 0 .709-.708V1.74a.708.708 0 0 0-.709-.708H7.406a.708.708 0 0 0-.708.708v7.792m5.312-5.166h2.657M12.01 7.2h2.657m-2.657 2.833h2.657M9.531 4.366h.354M9.531 7.2h.354m-.354 2.833h.354'
  />
);

export const viewBox = '0 0 18 18';
